import Core from "@/modules/core/service/Core";
import security from "@/main";
import { getApiBaseUrl } from "@/config";

const url = {
    upload         : "/api/incident/step/{0}/document/upload",
    properties     : "/api/incident/document/{0}/properties",
    type           : "/api/incident/document/{0}/type?id={1}",
    removedocument : "/api/incident/document/{0}",
    replacedocument: "/api/incident/document/{0}",
    document       : "/api/incident/step/{0}/document",
    incdocuments   : "/api/incident/{0}/document",
    docToUnit      : "/api/incident/{0}/document/unit/{1}",
    refresh        : "/api/incident/{0}/refresh",
    dmsdocument    : "/api/incident/document/{0}/version/{1}",
    deldocument    : "/api/document/{0}/version/{1}",
    combine        : "/api/incident/step/{0}/combine",
    move           : "/api/incident/document/{0}/move",
    versions       : "/api/document/{0}"
}

export default {
    upload: function (component, stepdataId, bidId, unitId, files) {
        Core.loading(component, true, component.$t("inb.loading.upload"));
        let formData = new FormData();
        Array.from(files).forEach ((file,index) => {
            formData.append ("file_" + index, file);
        });

        let uploadUrl = url.upload.replace("{0}", stepdataId);
        if (bidId) {
            uploadUrl = uploadUrl + "?bid=" + bidId;
        }

        if (unitId) {
            uploadUrl = bidId ? uploadUrl + "&unit=" + unitId : uploadUrl + "?unit=" + unitId;
        }

        return fetch(getApiBaseUrl() + uploadUrl, {
            method:'POST',
            headers: security.header(),
            body: formData
        }).then(response => {
            if (response.ok) {
                return response;
            }

            return new Promise((resolved, reject) => {
                reject(response.json());
            })
        }).then(res => res.json()).then(res => {
            Core.loading(component, false);
            return res;
        });
    },

    properties (component, documentId, properties) {
        return Core.method.put(url.properties, properties, documentId)
            .then((data) => {
                return Promise.resolve(data);
            })
            .catch ((data) => {
                Core.message.popup (component, data.id, data.parameter);
                return Promise.reject(data);
            });
    },

    setType (component, documentId, typeId) {
        return Core.method.put(url.type, null, documentId, typeId)
            .then((data) => {
                return Promise.resolve(data);
            })
            .catch ((data) => {
                Core.message.popup (component, data.id, data.parameter);
                return Promise.reject(data);
            });
    },

    replace: function (component, documentId, file) {
        Core.loading(component, true, component.$t("inb.loading.upload"));
        let formData = new FormData();
        formData.append ("file.name", file);
        return fetch(getApiBaseUrl() + url.replacedocument.replace("{0}", documentId), {
            method:'PUT',
            headers: security.header(),
            body: formData
        }).then(response => {
            if (response.ok) {
                return response;
            }

            return new Promise((resolved, reject) => {
                reject(response.json());
            })
        }).then(res => res.json()).then(res => {
            Core.loading(component, false);
            return res;
        });
    },

    refresh (incidentId, success, error) {
        Core.method.post(url.refresh, null, incidentId).then((data) => {
            success (data);
        }).catch((data) => {
            error (data)
        });
    },

    remove (component, documentId) {
        return Core.method.delete(url.removedocument, null, documentId)
            .then ((data) => {
                return Promise.resolve(data);
            })
            .catch ((data) => {
                Core.message.popup (component, data.id, data.parameter);
            });
    },

    assignToUnit (documentId, unitId, success) {
        Core.method.put(url.docToUnit, null, documentId, unitId).then((data) => {
            success(data);
        });
    },

    versions: {
        get (documentId) {
            return Core.method.get(url.versions, documentId);
        },

        remove (component, documentId, versionId) {
            return Core.method.delete(url.deldocument, null, documentId, versionId).then((data) => {
                return Promise.resolve(data);
            });
        },

        restore (component, documentId, versionId) {
            return Core.method.put(url.dmsdocument, null, documentId, versionId).then((data) => {
                return Promise.resolve(data);
            });
        },
    },


    combine (component, documentIds, targetStepDataId, targetFilename) {
        console.log("combine", targetStepDataId, documentIds, targetFilename)
        return Core.method.post(url.combine, {
            documents: documentIds,
            filename : targetFilename
        }, targetStepDataId).then(data => {
            return Promise.resolve(data);
        })
    },

    move (component, documentId, stepdataId, bidId) {
        return Core.method.put(url.move, {
            stepDataId: stepdataId,
            bidId     : bidId
        }, documentId);
    },

    byStep (collectionId, filter, success, error) {
        Core.method.post(url.document, filter, collectionId).then((data) => {
            success (data);
        }).catch((data) => {
            error (data)
        });
    },

    byIncident (incidentId, success) {
        Core.method.get(url.incdocuments, incidentId).then((data) => {
            success (data);
        }).catch((e) => {
            console.log(e);
        });
    },
}